/* eslint-disable */

export interface IssuedBankAccount {
  token?: string;
  fidelius_token?: string;
  ssn_fidelius_token?: string;
  /**
   * These have been deprecated in favour of external_account
   *
   * @deprecated
   */
  core_pro_customer_id?: string;
  /** @deprecated */
  core_pro_account_id?: string;
  state?: IssuedBankAccountBankAccountState;
  primary?: boolean;
  provider?: IssuedBankAccountBankAccountProvider;
  marqeta_account?: IssuedBankAccountMarqetaAccount | undefined;
  core_pro_account?: IssuedBankAccountCoreProAccount | undefined;
}

export enum IssuedBankAccountBankAccountState {
  OPEN = "OPEN",
  LOCKED = "LOCKED",
  CLOSED = "CLOSED",
}

export enum IssuedBankAccountBankAccountProvider {
  MARQETA = "MARQETA",
  CORE_PRO = "CORE_PRO",
  CASH_DDA = "CASH_DDA",
}

export interface IssuedBankAccountMarqetaAccount {
  user_token?: string;
}

export interface IssuedBankAccountCoreProAccount {
  customer_id?: string;
  account_id?: string;
}
